export default {
    SET_CLIENT: 'FILTERS::SET_CLIENT',
    SET_BU: 'FILTERS::SET_BU',
    SET_SHOP: 'FILTERS::SET_SHOP',
    SET_LOCATION: 'FILTERS::SET_LOCATION',
    SET_START_DATE: 'FILTERS::SET_START_DATE',
    SET_END_DATE: 'FILTERS::SET_END_DATE',
    SET_START_SETT_DATE: 'FILTERS::SET_START_SETT_DATE',
    SET_END_SETT_DATE: 'FILTERS::SET_END_SETT_DATE',
    SET_PAYMENT_TYPE: 'FILTERS::SET_PAYMENT_TYPE',
    SET_ACTIVITY: 'FILTERS::SET_ACTIVITY',
    SET_REPORTING_FILTER_OPEN: 'FILTERS::SET_REPORTING_FILTER_OPEN'
};



// WEBPACK FOOTER //
// ./src/store/filters/FilterActionsEnums.js